import { mockExchangeBalances } from '@/__mocks__';

export default {
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {String} wallet
   */
  async initExchangeSell({ commit, dispatch }, wallet) {
    commit('reset');
    commit('setLoading', true);
    const requests = [dispatch('fetchBalance', wallet)];
    await Promise.all(requests);
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {String} wallet
   */
  async fetchBalance({ commit }) {
    try {
      commit('setBalance', mockExchangeBalances());
    }
    catch (error) {
      commit('setError', error);
    }
  },
};
